export class Token {
  public static tokeNameInSotage = "tokenJWT";
  public static refreshTokenNameInStorage = "refreshToken";
  public static userNameInSotage = "currentUser";
  public static tokeNameBasicInSotage = "tokenBasic";
  public static allowedRole = "sysadmin";
}
